
    
    ;() => import("__mf__virtual/container_mf_2_ui__prebuild__react_mf_2_error_mf_2_boundary__prebuild__.js").catch(() => {});
    // dev uses dynamic import to separate chunks
    
    const {loadShare} = require("@module-federation/runtime")
    const {initPromise} = require("__mf__virtual/container_mf_2_ui__mf_v__runtimeInit__mf_v__.js")
    const res = initPromise.then(_ => loadShare("react-error-boundary", {
    customShareInfo: {shareConfig:{
      singleton: true,
      strictVersion: false,
      requiredVersion: "^4.1.2"
    }}}))
    const exportModule = await res.then(factory => factory())
    module.exports = exportModule
  